import { createContext } from "react";
import { SessionAgent, Session } from "../data/dtos/sessions.dto";

export interface ProfileContextType {
  basePath: string;
  language: string;
  mfa: {
    hasMfa: boolean;
    onMfa: () => void;
  };
  changePassword: {
    isError: boolean;
    isLoading: boolean;
    onChangePassword: (currentPassword?: string, newPassword?: string) => void;
  };
  onLogout: () => void;
  onSwitchToInvestor: (investorId: string) => void;
  onChangeLanguage: (language: string) => void;
  onDeleteAccount: () => void;
  sessions: {
    userSessions: Session[];
    activeUserSession: SessionAgent;
    onDeleteSession: (id: string) => void;
    isError: boolean;
    isLoading: boolean;
    onRefresh: () => void;
    correlationId?: string;
  };
  isKeycloakEnabled: boolean;
  authorizedMembers: {
    onRenderAuthorizedMembersUI: (
      domElementId: string,
      refresh: boolean,
    ) => void;
    correlationId?: string;
    isError: boolean;
    approveAuthorizedAccount: (code: string) => Promise<void>;
  };
  additionalAccreditation: boolean;
  taxFormsExpirationsEnabled?: boolean;
}

export const ProfileContext = createContext({} as ProfileContextType);

type ProfileProviderProps = {
  basePath: string;
  language: string;
  mfa: {
    hasMfa: boolean;
    onMfa: () => void;
  };
  onLogout: () => void;
  onSwitchToInvestor: (investorId: string) => void;
  changePassword: {
    isError: boolean;
    isLoading: boolean;
    onChangePassword: (currentPassword?: string, newPassword?: string) => void;
  };
  onChangeLanguage: (language: string) => void;
  onDeleteAccount: () => void;
  sessions: {
    userSessions: Session[];
    activeUserSession: SessionAgent;
    onDeleteSession: (id: string) => void;
    isError: boolean;
    isLoading: boolean;
    onRefresh: () => void;
    correlationId?: string;
  };
  isKeycloakEnabled: boolean;
  authorizedMembers: {
    onRenderAuthorizedMembersUI: (
      domElementId: string,
      refresh: boolean,
    ) => void;
    correlationId?: string;
    isError: boolean;
    approveAuthorizedAccount: (code: string) => Promise<void>;
  };
  additionalAccreditation: boolean;
  taxFormsExpirationsEnabled?: boolean;

  children: React.ReactNode;
};

export default function ProfileProvider({
  mfa,
  changePassword,
  sessions,
  children,
  language,
  onChangeLanguage,
  authorizedMembers,
  isKeycloakEnabled,
  basePath,
  onLogout,
  onSwitchToInvestor,
  onDeleteAccount,
  additionalAccreditation,
  taxFormsExpirationsEnabled,
}: ProfileProviderProps) {
  return (
    <ProfileContext.Provider
      value={{
        mfa,
        changePassword,
        language,
        onLogout,
        onSwitchToInvestor,
        onChangeLanguage,
        isKeycloakEnabled,
        sessions,
        authorizedMembers,
        basePath,
        onDeleteAccount,
        additionalAccreditation,
        taxFormsExpirationsEnabled,
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
}
